export function formatPersonName(input: string): string {
  const raw = String(input ?? '').trim();
  if (!raw) return '';

  // Collapse repeated whitespace.
  const s = raw.replace(/\s+/g, ' ');

  const words = s.split(' ');
  const out: string[] = [];

  for (const w of words) {
    if (!w) continue;

    // Keep acronyms (2-3 letters) as-is: NRI, CEO, etc.
    if (/^[A-Z]{2,3}$/.test(w)) {
      out.push(w);
      continue;
    }

    // If the token contains digits, keep it (e.g., "A-101", "2BHK" shouldn't be name anyway).
    if (/\d/.test(w)) {
      out.push(w);
      continue;
    }

    // Title-case each letter-only segment while preserving separators like '-' and '\''.
    const parts = w.split(/([-'])/g);
    const fixed = parts
      .map((p) => {
        if (p === '-' || p === "'") return p;
        if (!/^[A-Za-z]+$/.test(p)) return p; // keep non-letter segments
        return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
      })
      .join('');

    out.push(fixed);
  }

  return out.join(' ');
}

